import {type RefObject, useEffect, useState} from 'react';

export function useStickyStuck(ref: RefObject<HTMLElement | null>) {
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element?.parentElement) return;

    const sentinel = document.createElement('div');
    Object.assign(sentinel.style, {
      position: 'absolute',
      top: `${element.offsetTop}px`,
      height: '1px',
      width: '1px',
      pointerEvents: 'none',
      visibility: 'hidden',
    });

    element.parentElement.insertBefore(sentinel, element);

    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting),
      {threshold: 0},
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
      sentinel.remove();
    };
  }, [ref]);

  return isStuck;
}
